import React from "react";
import Cell from "../Cell";
import ModulePropertyDialog from "../ModulePropertyDialog";
import SectionPropertyDialog from "../SectionPropertyDialog";
import { CirclePoint } from "../../style";
import { isMobileOnly } from "react-device-detect";
const PropertyCell = ({
  type,
  rowId,
  tempId,
  tableManager,
  propertyList = [],
  errorMessage,
  dialogProps,
  sectionId,
  isFiller = false,
  colorIdentifiers = [],
  uniqueValues = null,
  onContextMenu,
}) => {
  const renderProperties = () => {
    if (tempId || !Array.isArray(propertyList)) return null;

    if (uniqueValues || type === "section") {
      const values = uniqueValues || [];

      return values.map((value, index) => (
        <div key={index} className="d-flex align-items-center gap-1">
          <div className="fs-10px">{value}</div>

          {index < values.length - 1 && <CirclePoint />}
        </div>
      ));
    }

    const shown = new Set();

    return propertyList
      .filter((property) =>
        [
          "module",
          "module_advanced",
          "section",
          "section_advanced",
          "project",
        ].includes(property.level)
      )
      .filter((property) => {
        if (
          colorIdentifiers.includes(property.identifier) ||
          !property.is_overridden_v2
        ) {
          return false;
        }

        const selectedOption = property.options.find((opt) => opt.selected);
        if (!selectedOption || shown.has(selectedOption.name)) return false;

        shown.add(selectedOption.name);
        return true;
      })
      .map((property, index, array) => {
        const selectedOption = property.options.find((opt) => opt.selected);
        return (
          <div key={index} className="d-flex align-items-center gap-1">
            <div>{selectedOption?.name}</div>

            {index < array.length - 1 && <CirclePoint />}
          </div>
        );
      });
  };

  return (
    <Cell
      rowType={type}
      rowId={rowId}
      column="property"
      status="focus"
      className="position-relative flex-grow-1 flex-shrink-1"
      tableManager={tableManager}
      isTemp={tempId}
      errorMessage={errorMessage}
      isFillerRow={isFiller}
      sectionId={sectionId}
      customStyles={{ maxWidth: isMobileOnly ? "194px" : "370px" }}
      onContextMenu={onContextMenu}
    >
      <div className="d-flex align-items-center flex-wrap gap-2">
        {renderProperties()}
      </div>

      {tableManager.isActive(type, rowId, "property") &&
        (type === "module" ? (
          <ModulePropertyDialog {...dialogProps} />
        ) : (
          <SectionPropertyDialog {...dialogProps} />
        ))}
    </Cell>
  );
};

export default PropertyCell;
